var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98745 0.528514C10.2478 0.788864 10.2478 1.21097 9.98745 1.47132L6.20078 5.25799L9.98745 9.04466C10.2478 9.30501 10.2478 9.72712 9.98745 9.98747C9.7271 10.2478 9.30499 10.2478 9.04464 9.98747L5.25798 6.2008L1.47132 9.98745C1.21097 10.2478 0.788864 10.2478 0.528514 9.98745C0.268165 9.7271 0.268165 9.30499 0.528514 9.04464L4.31517 5.25799L0.528514 1.47134C0.268165 1.21099 0.268165 0.78888 0.528514 0.52853C0.788864 0.268181 1.21097 0.268181 1.47132 0.52853L5.25798 4.31518L9.04464 0.528514C9.30499 0.268165 9.7271 0.268165 9.98745 0.528514Z",
    fill: "#141F2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.f3ab4c1efb39e068b36ab42e9e53cbd9.svg";
export { ForwardRef as ReactComponent };